import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import NRButtonProgressStyles from './NRButtonProgress.styles';
import clsx from 'clsx';
import Box from '@mui/material/Box';

const useStyles = makeStyles(NRButtonProgressStyles);

function NRButtonProgress({
  className,
  label,
  variant = 'contained',
  color = 'secondary',
  type,
  onClick,
  isLoading,
  disabled,
  id,
  extraStyles,
  extraStylesWrapper,
  fullWidth = true,
  startIcon
}) {
  const classes = useStyles();
  return (
    <Box className={clsx(classes.wrapper, className)} sx={{ ...extraStylesWrapper }}>
      <Button
        data-testid={'button-progress'}
        id={id}
        fullWidth={fullWidth}
        className={className}
        variant={variant}
        color={color}
        onClick={onClick}
        type={type}
        disabled={isLoading || disabled}
        sx={{ ...extraStyles }}
        startIcon={startIcon ?? null}
      >
        {label}
      </Button>
      {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
    </Box>
  );
}

export default NRButtonProgress;
